export default {"src":"/_next/static/media/sim_football.ddcb5855.svg","height":300,"width":300};